export default store => {
  return {
    async getDirections() {
      return await store.dispatch("directions/fetch", {});
    },
    async getDirection(params) {
      return await store.dispatch("directions/fetch", {
        type: "direction",
        params
      });
    }
  };
};
